import React, { useState } from "react";
import { getLogoSrc } from "../helpers/functionGlobal";

const LogoAseguradora = ({
  aseguradora,
  logo_url,
  className = "",
  alt = "",
}) => {
  const [hasError, setHasError] = useState(false);
  const logoSrc = getLogoSrc(aseguradora, logo_url);

  // Si no hay logo o hubo error, no mostrar nada
  if (!logoSrc || hasError) {
    return null;
  }

  const handleError = () => {
    console.warn(`Error al cargar logo de ${aseguradora}`);
    setHasError(true);
  };

  return (
    <img
      src={logoSrc}
      className={className}
      alt={alt || aseguradora}
      onError={handleError}
    />
  );
};

export default LogoAseguradora;
